export default __webpack_public_path__ + "static/media/leaf2.b28239b4.svg";